import dayjs from 'dayjs';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { getBasket_basket_basketSales_sale } from '../HeaderBasket/__generated__/getBasket';

type Props = {
  sale: getBasket_basket_basketSales_sale;
};

export const StyledSale = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 2px;
  padding: 1.6rem 1.6rem;
  background: #f5f5f5;
  border-radius: 2px;
`;

const Title = styled.div`
  color: #000;
  font-family: var(--font-primary);
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

const DeliveryStyled = styled.div`
  display: flex;
  align-items: center;
  font-family: var(--font-primary);
  font-weight: 400;
  font-size: 1.2rem;
  color: #555;
  span {
    font-weight: 600;
  }
`;

export default ({ sale }: Props) => {
  const { t } = useTranslation('shipping', { useSuspense: false });

  const minDate = sale.minimumDeliveryDate
    ? dayjs(sale.minimumDeliveryDate).format('DD/MM')
    : null;
  const maxDate = sale.maximumDeliveryDate
    ? dayjs(sale.maximumDeliveryDate).format('DD/MM')
    : sale.productDeliveryDate;

  const isSameDate = minDate === maxDate;

  return (
    <StyledSale>
      <Title>{sale.name}</Title>
      <DeliveryStyled>
        {minDate && !isSameDate ? (
          <div>
            {t('deliveredBetween')} <span>{minDate}</span> {t('deliveredAnd')} <span>{maxDate}</span>
          </div>
        ) : (
          <div>
            {t('estimatedDelivery')} <span>{maxDate}</span>
          </div>
        )}
      </DeliveryStyled>
    </StyledSale>
  );
};
